import {
  Component,
  inject,
  NgZone,
  signal,
  viewChild,
  viewChildren,
  ElementRef,
  input,
  output,
} from "@angular/core";
import { DeployUrlPipe } from "../../../../core/pipes/deploy-url.pipe";

@Component({
  selector: "cwo-rating-row",
  imports: [DeployUrlPipe],
  templateUrl: "./rating-row.component.html",
  styleUrl: "./rating-row.component.scss",
})
export class RatingRowComponent {
  readonly question = input.required<string>();
  readonly selected = output<number>();

  private readonly zone = inject(NgZone);

  readonly rowContainer = viewChild<ElementRef<HTMLElement>>("rowContainer");
  readonly emojiBtns = viewChildren<ElementRef<HTMLElement>>("emojiBtn");

  readonly selectedIndex = signal<number>(-1);
  readonly animIndex = signal<number>(-1);
  readonly animating = signal<boolean>(false);
  readonly dimmed = signal<boolean>(false);
  readonly transformStyle = signal<string | null>(null);
  readonly questionId = input.required<string>();


  readonly labels = ["terrible", "bad", "satisfied", "good", "excellent"];

  optionId(index: number): string {
    return `${this.questionId()}-${index}`;
  }

  onSelect(index: number): void {
    if (this.animating() || index === this.selectedIndex()) return;

    this.selectedIndex.set(index);
    this.selected.emit(index);
    this.animating.set(true);
    this.animIndex.set(index);

    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        const rowEl = this.rowContainer()?.nativeElement;
        const emojiEls = this.emojiBtns().map((ref) => ref.nativeElement);
        const selectedEl = emojiEls[index];
        if (!rowEl || !selectedEl) return;

        const rowRect = rowEl.getBoundingClientRect();
        const emojiRect = selectedEl.getBoundingClientRect();

        const tx = rowRect.left + rowRect.width / 2 - (emojiRect.left + emojiRect.width / 2);
        const ty = rowRect.top + rowRect.height / 2 - (emojiRect.top + emojiRect.height / 2);

        this.zone.run(() => {
          this.transformStyle.set(`translate(${tx}px, ${ty}px) scale(1.2)`);
          this.dimmed.set(true);
        });
      });

      setTimeout(() => {
        this.zone.run(() => {
          this.animIndex.set(-1);
          this.animating.set(false);
          this.dimmed.set(false);
          this.transformStyle.set(null);
        });
      }, 1000);
    });
  }
}
